<template>
  <div>
    <div class="rig_cont">
      <ul class>
        <li @click="scrollToTop(1)">
          <img class="imgs_g" src="../../image/fhdb.png" width="26" height="26" alt="">
          返回顶部
        </li>
        <li @click="scrollToTop(2)">
          <img class="imgs_g" src="../../image/fczzr.png" width="26" height="26" alt="">
          发出租转让
        </li>
        <li @click="scrollToTop(3)">
          <img class="imgs_g" src="../../image/fbqz.png" width="26" height="26" alt="">
          发布求租
        </li>
        <li @click="scrollToTop(4)">
          <img class="imgs_g" src="../../image/wdsc.png" width="26" height="26" alt="">
          我的收藏
        </li>
        <li @click="scrollToTop(5)">
          <img class="imgs_g" src="../../image/sjb.png" width="26" height="26" alt="">
          手机版
        </li>
        <li @click="scrollToTop(6)">
          <img class="imgs_g" src="../../image/lxkf.png" width="26" height="26" alt="">
          联系客服
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {

    };
  },
  created() {

  },
  mounted() {

  },
  methods: {
    scrollToTop(index) {
      switch (index) {
        case 1:
          window.scrollTo({
            top: 0,
            behavior: 'smooth' // 平滑滚动
          });
          break;
        case 2:
        this.$router.push({ name:'PublishRelease',query:{ dataIndex: 0 } })
          break;
          case 3:
        this.$router.push({ name:'PublishRelease',query:{ dataIndex: 2 }})
          break;
          case 4:
        this.$router.push({ name:'ProfileCollect' })
          break;
          case 5:
        this.$router.push({ name:'HelpMini' })
          break;
        default:
        this.$router.push({ name:'HelpContact' })
          break;
      }

    }
  },
}
</script>
<style scoped lang='less'>
.rig_cont {
  z-index: 99999999 !important;
  position: absolute;
  right: 70px;
  top: 140px;
  width: 150px;

  ul {
    li {
      width: 150px;
      height: 50px;
      background: #0074FF;
      border-radius: 56px 56px 56px 56px;
      margin: 16px 0;
      list-style: none;
      display: flex;
      align-items: center;
      cursor: pointer;

      font-weight: 500;
      font-size: 14px;
      color: #FFFFFF;

    }

    .imgs_g {
      margin: 0 10px 0 20px;
    }
  }
}</style>